/* tslint:disable */
/* eslint-disable */
/**
 * EN.ClientContract
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnvironmentSettingsDto } from '../models';
/**
 * EnvironmentSettingsApi - axios parameter creator
 * @export
 */
export const EnvironmentSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get environment settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvironmentSettings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EnvironmentSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication XApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnvironmentSettingsApi - functional programming interface
 * @export
 */
export const EnvironmentSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnvironmentSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get environment settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnvironmentSettings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironmentSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnvironmentSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnvironmentSettingsApi - factory interface
 * @export
 */
export const EnvironmentSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnvironmentSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get environment settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvironmentSettings(options?: any): AxiosPromise<EnvironmentSettingsDto> {
            return localVarFp.getEnvironmentSettings(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnvironmentSettingsApi - object-oriented interface
 * @export
 * @class EnvironmentSettingsApi
 * @extends {BaseAPI}
 */
export class EnvironmentSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Get environment settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentSettingsApi
     */
    public getEnvironmentSettings(options?: any) {
        return EnvironmentSettingsApiFp(this.configuration).getEnvironmentSettings(options).then((request) => request(this.axios, this.basePath));
    }
}
